const LANDING_PAGE_LINK_REGEX = /(.+)\/dp\/(.+)\/?/;

const LANDING_PAGE_ENVIRONMENTS = {
  MOBILE: 'Mobile',
  DESKTOP: 'Desktop',
};

export {
  LANDING_PAGE_LINK_REGEX,
  LANDING_PAGE_ENVIRONMENTS,
}
